import { render, staticRenderFns } from "./ImpressoraList.vue?vue&type=template&id=3b1c19fd"
import script from "./ImpressoraList.vue?vue&type=script&lang=js"
export * from "./ImpressoraList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports